import { render, staticRenderFns } from "./project-item-add-multiple-button.vue?vue&type=template&id=2a42759e&"
import script from "./project-item-add-multiple-button.vue?vue&type=script&lang=js&"
export * from "./project-item-add-multiple-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports